/* unplugin-vue-components disabled */import script from "./home.vue?vue&type=script&setup=true&lang=js"
export * from "./home.vue?vue&type=script&setup=true&lang=js"

import "./home.vue?vue&type=style&index=0&id=235197e9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-235197e9"]])

export default __exports__